import { computed } from "vue";
import { useServiceStore } from "../store/service";

export function useAccessData() {
  const service = useServiceStore();

  const hasDns = computed(() => service.ctx.gameProfile?.hasDns);

  const serverIpAddress = computed(() => {
    const gameServer = service.ctx.sys?.gameServer;
    if (!gameServer) {
      return null;
    }
    const serverIp = gameServer.serverIp;
    const serverPort = gameServer.serverPort;
    return `${serverIp}:${serverPort}`;
  });

  const rsid = computed(() => service.ctx.service?.config?.rsid);

  const customDns = computed(() => service.ctx.service?.config?.dnsNames?.[0]);

  const defaultDnsName = computed(() =>
    rsid.value ? `${rsid.value?.region.toLowerCase()}${rsid.value?.id}.g-portal.game` : undefined,
  );

  const dnsName = computed(() => {
    if (customDns.value && customDns.value.length >= 2) {
      return `${customDns.value[0]}.${customDns.value[1]}`;
    }
    return defaultDnsName.value;
  });

  const accessDataFn = computed(() => service.ctx.gameProfile?.accessDataFn);
  const copyAccessDataFn = computed(() => service.ctx.gameProfile?.copyAccessDataFn);

  const accessData = computed(() => {
    if (hasDns.value) {
      return dnsName.value;
    }
    if (accessDataFn.value) {
      return accessDataFn.value();
    }
    return serverIpAddress.value;
  });

  const copyAccessData = computed(() => (copyAccessDataFn.value ? copyAccessDataFn.value() : accessData.value));

  return { hasDns, serverIpAddress, defaultDnsName, dnsName, accessData, copyAccessData };
}
